import * as React from 'react';
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
} from '@/components/ui/empty';

interface FeatureDisabledProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

// Shared empty-state for every tenant-flag-gated route (CAD viewer, CAD
// thickness, design verification). Fills the content area and centres the
// message so a disabled feature reads as an intentional state rather than a
// broken page.
const FeatureDisabled: React.FC<FeatureDisabledProps> = ({ icon, title, description }) => (
  <div className="flex h-[calc(100vh-64px)] flex-col p-4">
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">{icon}</EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  </div>
);

export default FeatureDisabled;
